import { StylesConfig } from 'react-select';
import { ModernSelectOption } from 'src/components/ModernSelect';

// Shared styling for every Cal.com dropdown (booking-link picker, event-type select, …) so they
// all read like the sky-bordered, sentence-case text inputs in the Cal.com dialogs — not the
// uppercase brand-indigo ModernSelect default. Pair with size="regular" on the ModernSelect.
export const CALCOM_SELECT_STYLES: StylesConfig<ModernSelectOption, false> = {
  control: (base: any, state: any) => ({
    ...base,
    borderColor: state.isDisabled ? '#d1d5db' : 'var(--color-sky-dark)',
    borderRadius: '6px',
    boxShadow: state.isFocused ? '0 0 0 1px var(--color-sky-dark)' : 'none',
    '&:hover': {
      borderColor: 'var(--color-sky-dark)',
    },
  }),
  singleValue: (base: any) => ({
    ...base,
    textTransform: 'none',
    letterSpacing: 'normal',
    fontWeight: 600,
    fontSize: '13px',
    color: 'var(--color-ink-light)',
  }),
  placeholder: (base: any) => ({
    ...base,
    textTransform: 'none',
    letterSpacing: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    color: 'var(--color-ink-lighter)',
  }),
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    color: state.isDisabled ? '#9ca3af' : 'var(--color-ink-lighter)',
    '&:hover': {
      color: 'var(--color-ink-light)',
    },
  }),
};
